import { useQuery } from '@tanstack/react-query';

import { type ResourceId } from '@app/client';
import { callGetUserLiquidId } from '@app/client/resources/nbe/liquid-id-request-handler';

export const LID_CACHE = 'LID_CACHE';
export const useGetLiquidIDItems = (userId: ResourceId) => {
    const cache = [LID_CACHE, userId];

    return useQuery(
        cache,
        ({ signal }) =>
            callGetUserLiquidId({
                userId,
                settings: {
                    signal,
                },
            }),
        {
            select: (res) => {
                if (res.ok) return res.value;
            },
            retry: false,
            enabled: Boolean(userId),
        },
    );
};
